import React from 'react'
import './App.css'
import Listwrap from './components/listWrap/listWrap.coponent'

const App = () => {
  return (
    <div className='App'>
      <h1>Coutries of Asia</h1>
      <hr />
      <Listwrap />
    </div>
  )
}

export default App
